export const EMAIL_TEMPLATE_CATEGORIES = ['Auth', 'Payment', 'Resource', 'Security', 'System'] as const
export type EmailTemplateCategory = (typeof EMAIL_TEMPLATE_CATEGORIES)[number]

export interface EmailTemplateListDto {
  id: string
  key: string
  subject: string
  category: string
  culture: string
  isActive: boolean
  createdAt: string
}

export interface EmailTemplateDetailDto extends EmailTemplateListDto {
  body: string
  updatedAt?: string
}

export interface CreateEmailTemplateRequest {
  key: string
  subject: string
  body: string
  category: string
  culture: string
}

export interface UpdateEmailTemplateRequest {
  subject?: string
  body?: string
  category?: string
  culture?: string
  isActive?: boolean
}
